import { render, staticRenderFns } from "./DefaultMessagesAddView.vue?vue&type=template&id=49ddbf2d"
import script from "./DefaultMessagesAddView.vue?vue&type=script&lang=js"
export * from "./DefaultMessagesAddView.vue?vue&type=script&lang=js"
import style0 from "./DefaultMessagesAddView.vue?vue&type=style&index=0&id=49ddbf2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports